import * as React from "react";

function SvgComponent(props) {
  return (
    <svg width={"100%"} viewBox="0 0 184.94 161.83" {...props}>
      <defs>
        <linearGradient
          id="servicescardphoto4__linear-gradient"
          x1={15319.05}
          y1={2764.88}
          x2={15300.73}
          y2={2774.91}
          gradientTransform="translate(-15299.93 -2685.46)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#9f79c8" />
          <stop offset={0.14} stopColor="#a580cb" />
          <stop offset={0.33} stopColor="#b492d3" />
          <stop offset={0.55} stopColor="#cdb0e1" />
          <stop offset={0.58} stopColor="#d1b4e3" />
          <stop offset={0.76} stopColor="#dbc4e9" />
          <stop offset={1} stopColor="#ebdef3" />
        </linearGradient>
        <linearGradient
          id="servicescardphoto4__linear-gradient-2"
          x1={17458.24}
          y1={88.22}
          x2={17450.91}
          y2={76.56}
          gradientTransform="translate(-17440.89)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.01} stopColor="#c1a1d5" />
          <stop offset={0.23} stopColor="#c9abdc" />
          <stop offset={0.36} stopColor="#d1b4e3" />
          <stop offset={0.43} stopColor="#b395d6" />
          <stop offset={0.49} stopColor="#9c7dcb" />
          <stop offset={0.56} stopColor="#8e6ec5" />
          <stop offset={0.61} stopColor="#8969c3" />
          <stop offset={0.76} stopColor="#9471c6" />
          <stop offset={1} stopColor="#b086cc" />
        </linearGradient>
        <linearGradient
          id="servicescardphoto4__linear-gradient-3"
          x1={-21265.93}
          y1={77.65}
          x2={-21252.44}
          y2={84.65}
          gradientTransform="matrix(-1 0 0 1 -21241.48 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#8770b8" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="servicescardphoto4__linear-gradient-4"
          x1={-21255.5}
          y1={78.27}
          x2={-21258.7}
          y2={84.76}
          gradientTransform="matrix(-1 0 0 1 -21241.48 0)"
          xlinkHref="#servicescardphoto4__linear-gradient-2"
        />
        <linearGradient
          id="servicescardphoto4__linear-gradient-5"
          x1={15336.05}
          y1={2774.89}
          x2={15317.73}
          y2={2784.92}
          xlinkHref="#servicescardphoto4__linear-gradient"
        />
        <linearGradient
          id="servicescardphoto4__linear-gradient-6"
          x1={17475.23}
          y1={98.24}
          x2={17467.91}
          y2={86.58}
          xlinkHref="#servicescardphoto4__linear-gradient-2"
        />
        <linearGradient
          id="servicescardphoto4__linear-gradient-7"
          x1={-21282.93}
          y1={87.67}
          x2={-21269.44}
          y2={94.66}
          xlinkHref="#servicescardphoto4__linear-gradient-3"
        />
        <linearGradient
          id="servicescardphoto4__linear-gradient-8"
          x1={-21272.5}
          y1={88.28}
          x2={-21275.7}
          y2={94.78}
          gradientTransform="matrix(-1 0 0 1 -21241.48 0)"
          xlinkHref="#servicescardphoto4__linear-gradient-2"
        />
        <linearGradient
          id="servicescardphoto4__linear-gradient-9"
          x1={-21282.62}
          y1={49.72}
          x2={-21310.03}
          y2={101.97}
          gradientTransform="matrix(-1 0 0 1 -21241.48 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#744ca1" />
          <stop offset={0.53} stopColor="#9f79c8" />
          <stop offset={0.64} stopColor="#a580cb" />
          <stop offset={0.8} stopColor="#b492d3" />
          <stop offset={0.98} stopColor="#cdb0e1" />
          <stop offset={1} stopColor="#d1b4e3" />
        </linearGradient>
        <linearGradient
          id="servicescardphoto4__linear-gradient-10"
          x1={-21381.13}
          y1={139.32}
          x2={-21367.65}
          y2={133.27}
          xlinkHref="#servicescardphoto4__linear-gradient-3"
        />
        <radialGradient
          id="servicescardphoto4__radial-gradient"
          cx={-21257.03}
          cy={81.16}
          r={1.71}
          gradientTransform="matrix(-1 0 0 1 -21241.48 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#eeebf2" />
          <stop offset={0.58} stopColor="#d4d1d8" />
          <stop offset={0.94} stopColor="#a5a6b9" />
          <stop offset={1} stopColor="#9d9eb3" />
        </radialGradient>
        <radialGradient
          id="servicescardphoto4__radial-gradient-2"
          cx={-21274.25}
          cy={91.19}
          r={1.71}
          xlinkHref="#servicescardphoto4__radial-gradient"
        />
        <radialGradient
          id="servicescardphoto4__radial-gradient-3"
          cx={-21324.09}
          cy={120.18}
          r={1.71}
          xlinkHref="#servicescardphoto4__radial-gradient"
        />
        <radialGradient
          id="servicescardphoto4__radial-gradient-4"
          cx={-21375.26}
          cy={149.78}
          r={1.71}
          xlinkHref="#servicescardphoto4__radial-gradient"
        />
        <radialGradient
          id="servicescardphoto4__radial-gradient-5"
          cx={-21424.09}
          cy={136.66}
          r={0.62}
          gradientTransform="matrix(-1 0 0 1 -21241.48 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#9f19ab" />
          <stop offset={0.01} stopColor="#9c19a8" />
          <stop offset={0.13} stopColor="#73127c" />
          <stop offset={0.25} stopColor="#500d56" />
          <stop offset={0.38} stopColor="#330836" />
          <stop offset={0.52} stopColor="#1c041e" />
          <stop offset={0.66} stopColor="#0c020d" />
          <stop offset={0.81} stopColor="#030003" />
          <stop offset={1} />
        </radialGradient>
        <radialGradient
          id="servicescardphoto4__radial-gradient-6"
          cx={-21405.82}
          cy={147.17}
          r={16}
          xlinkHref="#servicescardphoto4__radial-gradient-5"
        />
        <radialGradient
          id="servicescardphoto4__radial-gradient-7"
          cx={-28330.71}
          cy={-15333.2}
          r={13.4}
          gradientTransform="matrix(-.09 -.18 -.88 .47 -16029.92 2340.95)"
          xlinkHref="#servicescardphoto4__radial-gradient-5"
        />
      </defs>
      <g
        style={{
          isolation: "isolate",
        }}
      >
        <g id="servicescardphoto4__Layer_2" data-name="Layer 2">
          <g id="servicescardphoto4__Layer_1-2" data-name="Layer 1">
            <path
              d="M27.56 83.25c0 2.45-.84 4.19-2.22 5L21 90.82c-1.43.8-.52-1-2.69-2.27-4.43-2.55-7.97-8.65-7.97-13.67 0-2.48-2.3-2.5-.89-3.33L14.11 69c1.43-.77 3.38-.63 5.53.61 4.36 2.5 7.92 8.62 7.92 13.64z"
              fill="#474756"
            />
            <path
              d="M23 85.85c0 5-3.54 7.05-7.92 4.52A17.43 17.43 0 017.13 76.7c0-5 3.54-7 7.92-4.51S23 80.83 23 85.85z"
              fill="#545466"
            />
            <path
              d="M15 75.8c-2.83-1.63-5.12-.32-5.12 2.92A11.28 11.28 0 0015 87.55c2.82 1.63 5.12.32 5.12-2.92A11.3 11.3 0 0015 75.8z"
              fill="url(#servicescardphoto4__linear-gradient)"
            />
            <path
              d="M16.81 86.38a11.28 11.28 0 01-5.12-8.83 4.51 4.51 0 01.6-2.42c-1.45.2-2.42 1.48-2.42 3.59A11.28 11.28 0 0015 87.55c2 1.13 3.65.85 4.51-.5a4.28 4.28 0 01-2.7-.67z"
              fill="url(#servicescardphoto4__linear-gradient-2)"
            />
            <path
              d="M18.54 84.18c0 2-1.42 2.81-3.16 1.8a7 7 0 01-3.16-5.45c0-2 1.41-2.81 3.16-1.8a7 7 0 013.16 5.45z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="url(#servicescardphoto4__linear-gradient-3)"
            />
            <path
              d="M18.28 83c0 1.7-1.19 2.38-2.67 1.53a5.91 5.91 0 01-2.68-4.62c0-1.69 1.2-2.38 2.68-1.52A5.86 5.86 0 0118.28 83z"
              fill="url(#servicescardphoto4__linear-gradient-4)"
            />
            <path
              d="M17.55 83.54c0 1.69-1.19 2.37-2.67 1.52a5.89 5.89 0 01-2.68-4.61c0-1.7 1.2-2.38 2.68-1.53a5.88 5.88 0 012.67 4.62z"
              fill="#e7f1f7"
            />
            <path
              d="M27.27 83.22c0 2.47-.85 4.21-2.24 5.06l-4.22 2.45c-1.44.8-.52-1-2.71-2.29-4.4-2.54-8-8.69-8-13.75 0-2.49-2.3-2.51-.89-3.35l4.49-2.48c1.44-.78 3.4-.64 5.57.61 4.43 2.53 8 8.7 8 13.75z"
              fill="#4c4c5e"
            />
            <path
              d="M22.85 85.73c0 5-3.57 7.09-8 4.54s-8-8.69-8-13.74 3.56-7.09 8-4.55 8 8.7 8 13.75z"
              fill="#474756"
            />
            <path
              d="M20.56 84.41c0 3.6-2.55 5-5.68 3.24a12.53 12.53 0 01-5.68-9.8c0-3.6 2.54-5 5.68-3.24a12.54 12.54 0 015.68 9.8z"
              fill="#e7f1f7"
            />
            <path
              d="M20.56 84.41a4.9 4.9 0 01-.72 2.75c-1 .71-2.39.68-4-.23a11.69 11.69 0 01-5.3-9.14c0-2.43 1.24-3.81 3-3.75a7.09 7.09 0 011.29.57 12.54 12.54 0 015.73 9.8z"
              fill="#e7f1f7"
            />
            <path
              d="M11.63 73.91A4 4 0 0010 77.54a12.55 12.55 0 005.68 9.8 4.61 4.61 0 003.25.7c-1 .6-2.46.52-4-.39a12.53 12.53 0 01-5.68-9.8c-.05-2.21.91-3.61 2.38-3.94z"
              fill="#474756"
            />
            <path
              d="M17 82c0 .95-.67 1.33-1.49.85a3.26 3.26 0 01-1.48-2.56c0-.94.66-1.32 1.48-.85A3.29 3.29 0 0117 82z"
              fill="url(#servicescardphoto4__radial-gradient)"
            />
            <path
              d="M14.94 76.25a1.65 1.65 0 00.75 1.28c.41.24.74 0 .74-.42a1.62 1.62 0 00-.74-1.28c-.41-.24-.75-.05-.75.42zm0 8.69a1.65 1.65 0 00.75 1.28c.41.24.74 0 .74-.42a1.62 1.62 0 00-.74-1.28c-.41-.24-.75-.05-.75.42zm-1.41-8.83c-.29-.5-.76-.78-1-.61s-.29.7 0 1.2.76.77 1 .61.29-.71 0-1.2zm4.31 9.83c.29.5.76.77 1.05.61s.29-.71 0-1.21-.76-.77-1.05-.6-.29.7 0 1.2zm-6.68-7.53a1.64 1.64 0 00.74 1.28c.41.23.74 0 .74-.43A1.6 1.6 0 0011.9 78c-.41-.25-.74-.06-.74.41zm7.57 4.37a1.64 1.64 0 00.74 1.28c.41.24.74 0 .74-.42a1.62 1.62 0 00-.74-1.28c-.41-.24-.74-.05-.74.42zm-6.25.07c.29.5.76.77 1 .6s.29-.7 0-1.2-.76-.77-1-.6-.29.7 0 1.2zm5.36-3c.29.5.76.77 1.05.6s.29-.7 0-1.2-.76-.77-1.05-.61-.29.66 0 1.16z"
              fill="#474756"
            />
            <path
              d="M18 82a1.53 1.53 0 01-.61 1.39l-.93.56c-.4.22-.14-.29-.75-.63a4.85 4.85 0 01-2.19-3.79c0-.69-.64-.7-.25-.93l1-.55a1.56 1.56 0 011.55.16A4.85 4.85 0 0118 82z"
              fill="#545466"
            />
            <path
              d="M17 82.59c0 1.39-1 2-2.2 1.25a4.83 4.83 0 01-2.19-3.79c0-1.39 1-2 2.19-1.25a4.83 4.83 0 012.2 3.79z"
              fill="#545466"
            />
            <path
              d="M44.56 93.26c0 2.46-.85 4.2-2.22 5L38 100.84c-1.43.8-.52-1-2.69-2.27-4.43-2.57-7.98-8.65-7.98-13.67 0-2.49-2.29-2.51-.89-3.33L31.11 79c1.42-.77 3.37-.63 5.53.62 4.36 2.5 7.92 8.62 7.92 13.64z"
              fill="#474756"
            />
            <path
              d="M40 95.87c0 5-3.55 7-7.92 4.52s-7.93-8.65-7.93-13.67 3.55-7 7.93-4.52S40 90.85 40 95.87z"
              fill="#545466"
            />
            <path
              d="M32 85.81c-2.82-1.63-5.12-.32-5.12 2.92A11.32 11.32 0 0032 97.57c2.83 1.63 5.13.32 5.13-2.92A11.31 11.31 0 0032 85.81z"
              fill="url(#servicescardphoto4__linear-gradient-5)"
            />
            <path
              d="M33.81 96.4a11.31 11.31 0 01-5.13-8.84 4.38 4.38 0 01.61-2.41c-1.45.19-2.43 1.48-2.43 3.58A11.32 11.32 0 0032 97.57c2 1.12 3.66.84 4.52-.51a4.27 4.27 0 01-2.71-.66z"
              fill="url(#servicescardphoto4__linear-gradient-6)"
            />
            <path
              d="M35.54 94.19c0 2-1.42 2.81-3.16 1.81a7 7 0 01-3.16-5.45c0-2 1.41-2.81 3.16-1.8a7 7 0 013.16 5.44z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="url(#servicescardphoto4__linear-gradient-7)"
            />
            <path
              d="M35.28 93.05c0 1.69-1.2 2.37-2.67 1.52A5.89 5.89 0 0129.93 90c0-1.7 1.2-2.38 2.68-1.53a5.91 5.91 0 012.67 4.58z"
              fill="url(#servicescardphoto4__linear-gradient-8)"
            />
            <path
              d="M34.55 93.55c0 1.7-1.2 2.38-2.67 1.53a5.91 5.91 0 01-2.68-4.62c0-1.7 1.2-2.38 2.68-1.53a5.92 5.92 0 012.67 4.62z"
              fill="#e7f1f7"
            />
            <path
              d="M44.48 93.25c0 2.46-.85 4.21-2.23 5.06L38 100.76c-1.44.8-.52-1-2.71-2.29-4.4-2.54-8-8.7-8-13.75 0-2.49-2.31-2.51-.89-3.35l4.6-2.48c1.44-.78 3.4-.64 5.56.61 4.36 2.5 7.92 8.7 7.92 13.75z"
              fill="#4c4c5e"
            />
            <path
              d="M40.06 95.76c0 5-3.56 7.08-8 4.54s-8-8.69-8-13.74 3.57-7.09 8-4.55 8 8.7 8 13.75z"
              fill="#474756"
            />
            <path
              d="M37.77 94.44c0 3.6-2.54 5-5.68 3.23a12.52 12.52 0 01-5.68-9.79c0-3.6 2.55-5 5.68-3.24a12.51 12.51 0 015.68 9.8z"
              fill="#e7f1f7"
            />
            <path
              d="M37.77 94.44a4.82 4.82 0 01-.72 2.75c-1 .7-2.39.68-4-.23a11.68 11.68 0 01-5.3-9.14c0-2.43 1.24-3.81 3-3.75a6.72 6.72 0 011.28.57 12.51 12.51 0 015.74 9.8z"
              fill="#e7f1f7"
            />
            <path
              d="M28.85 83.94a4 4 0 00-1.64 3.63 12.49 12.49 0 005.68 9.79 4.59 4.59 0 003.24.71c-1 .6-2.46.52-4-.4a12.52 12.52 0 01-5.68-9.79c-.04-2.22.93-3.62 2.4-3.94z"
              fill="#474756"
            />
            <path
              d="M34.26 92c0 .95-.67 1.32-1.49.85a3.26 3.26 0 01-1.48-2.56c0-.94.66-1.32 1.48-.85A3.27 3.27 0 0134.26 92z"
              fill="url(#servicescardphoto4__radial-gradient-2)"
            />
            <path
              d="M32.16 86.28a1.64 1.64 0 00.74 1.28c.41.23.75 0 .75-.43a1.65 1.65 0 00-.75-1.28c-.41-.23-.74-.04-.74.43zm0 8.69a1.64 1.64 0 00.74 1.28c.41.24.75 0 .75-.42a1.63 1.63 0 00-.75-1.28c-.41-.24-.74-.05-.74.45zm-1.41-8.84c-.29-.5-.76-.77-1.05-.6s-.29.7 0 1.2.76.77 1.05.61.25-.71 0-1.21zM35.06 96c.29.5.76.77 1 .61s.29-.71 0-1.21-.76-.77-1-.6-.29.67 0 1.2zm-6.69-7.53a1.65 1.65 0 00.75 1.28c.41.23.74 0 .74-.43a1.64 1.64 0 00-.74-1.32c-.41-.22-.75 0-.75.44zM36 92.81a1.64 1.64 0 00.74 1.28c.41.24.74 0 .74-.42a1.62 1.62 0 00-.74-1.28c-.46-.24-.74-.05-.74.42zm-6.25.07c.29.5.76.77 1.05.6s.29-.7 0-1.2-.76-.77-1.05-.61-.34.71-.05 1.21zm5.36-3.06c.29.5.76.77 1 .61s.29-.7 0-1.2-.76-.78-1-.61-.34.7-.05 1.2z"
              fill="#474756"
            />
            <path
              d="M35.2 92.05a1.54 1.54 0 01-.62 1.39l-.92.55c-.4.23-.15-.28-.75-.62a4.87 4.87 0 01-2.2-3.79c0-.69-.63-.7-.24-.93l1-.56a1.55 1.55 0 011.54.17 4.81 4.81 0 012.19 3.79z"
              fill="#545466"
            />
            <path
              d="M34.22 92.62c0 1.39-1 1.95-2.2 1.25a4.85 4.85 0 01-2.19-3.79c0-1.39 1-2 2.19-1.25a4.86 4.86 0 012.2 3.79z"
              fill="#545466"
            />
            <g>
              <path
                fill="#9aa0a6"
                d="M74.32 104.92v7.56l-25.51-14.8v-7.54l25.51 14.78zM74.32 104.92v7.56l7.17-4.07v-7.59l-7.17 4.1z"
              />
              <path
                fill="url(#servicescardphoto4__linear-gradient-9)"
                d="M81.49 100.82l-7.17 4.1-25.51-14.78 7.17-4.09 25.51 14.77z"
              />
            </g>
            <g>
              <path
                fill="#8c9399"
                d="M1.61 62.15v9.63l-.94-.75v-9.61l.94.73zM1.61 62.15v9.63l22.96-12.9v-9.65L1.61 62.15z"
              />
              <path
                fill="#e7f1f7"
                d="M24.57 49.23L1.61 62.15l-.94-.73 22.96-12.91.94.72z"
              />
            </g>
            <path
              fill="#c5d4dd"
              d="M44.02 86.16v14.35l-2.56-1.47V87.62L6.67 67.54v11.41l-2.55-1.47V63.13l39.9 23.03z"
            />
            <path
              fill="#b4c4cc"
              d="M44.03 86.19v14.35l2.48-1.39V84.71l-2.48 1.48z"
            />
            <g>
              <path
                fill="#b4c4cc"
                d="M70.12 111.23l-1.3.77-21.18-12.2 1.31-.75 21.17 12.18z"
              />
              <path
                fill="#b4c4cc"
                d="M47.61 92.04v7.77l1.34-.75v-7.82l-1.34.8z"
              />
              <path
                d="M45.69 89.9v10.95l25 14.53v-11zm2 3.38l21.15 12.18V112l-21.2-12.27z"
                fill="#c5d4dd"
              />
              <path
                fill="#b4c4cc"
                d="M70.73 104.34v11.04l1.65-.83v-11.11l-1.65.9zM72.38 103.44l-1.65.9L45.69 89.9l1.66-.87 25.03 14.41z"
              />
            </g>
            <g>
              <path
                d="M94.64 122.39c0 2.46-.85 4.19-2.23 5L88 130c-1.43.8-.51-1-2.69-2.28-4.37-2.52-7.92-8.64-7.92-13.66 0-2.49-2.3-2.51-.89-3.34l4.66-2.58c1.43-.77 3.38-.63 5.53.61 4.4 2.5 7.95 8.62 7.95 13.64z"
                fill="#474756"
              />
              <path
                d="M90.05 125c0 5-3.55 7-7.93 4.52s-7.92-8.65-7.92-13.67 3.55-7 7.92-4.52S90.05 120 90.05 125z"
                fill="#545466"
              />
              <path
                d="M82.06 114.94c-2.82-1.63-5.12-.32-5.12 2.92a11.34 11.34 0 005.12 8.84c2.82 1.63 5.12.32 5.12-2.93a11.3 11.3 0 00-5.12-8.83z"
                fill="#b4c4cc"
              />
              <path
                d="M84.63 122.68c0 1.69-1.2 2.38-2.68 1.52a5.88 5.88 0 01-2.67-4.61c0-1.7 1.19-2.38 2.67-1.53a5.91 5.91 0 012.68 4.62z"
                fill="#e7f1f7"
              />
              <path
                d="M94.32 122.25c0 2.46-.85 4.21-2.23 5.06l-4.22 2.44c-1.44.81-.52-1-2.71-2.28-4.4-2.54-8-8.7-8-13.75 0-2.5-2.31-2.52-.9-3.35l4.5-2.49c1.43-.77 3.4-.63 5.56.62 4.43 2.5 8 8.69 8 13.75z"
                fill="#4c4c5e"
              />
              <path
                d="M89.9 124.76c0 5-3.57 7.08-8 4.54s-8-8.7-8-13.75 3.57-7.08 8-4.54 8 8.7 8 13.75z"
                fill="#474756"
              />
              <path
                d="M87.61 123.43c0 3.6-2.54 5-5.68 3.24a12.49 12.49 0 01-5.68-9.79c0-3.6 2.54-5 5.68-3.24a12.49 12.49 0 015.68 9.79z"
                fill="#e7f1f7"
              />
              <path
                d="M87.61 123.43a4.83 4.83 0 01-.72 2.76c-1 .7-2.39.68-4-.23a11.68 11.68 0 01-5.3-9.15c0-2.42 1.24-3.8 3-3.74a5.67 5.67 0 011.28.57 12.49 12.49 0 015.74 9.79z"
                fill="#e7f1f7"
              />
              <path
                d="M78.69 112.93a4 4 0 00-1.64 3.64 12.49 12.49 0 005.68 9.79 4.58 4.58 0 003.24.71c-1 .6-2.46.51-4-.4a12.49 12.49 0 01-5.68-9.79c-.04-2.22.92-3.62 2.4-3.95z"
                fill="#474756"
              />
              <path
                d="M84.09 121c0 .94-.66 1.32-1.48.85a3.29 3.29 0 01-1.49-2.56c0-1 .67-1.33 1.49-.85a3.26 3.26 0 011.48 2.56z"
                fill="url(#servicescardphoto4__radial-gradient-3)"
              />
              <path
                d="M82 115.28a1.64 1.64 0 00.74 1.28c.41.23.74 0 .74-.43a1.64 1.64 0 00-.74-1.28c-.41-.23-.74-.04-.74.43zm0 8.72a1.64 1.64 0 00.74 1.28c.41.23.74 0 .74-.43a1.64 1.64 0 00-.74-1.28c-.41-.26-.74-.07-.74.43zm-1.41-8.84c-.29-.5-.76-.77-1-.6s-.29.7 0 1.2.76.77 1 .61.29-.74 0-1.24zm4.3 9.84c.29.5.76.77 1 .6s.29-.7 0-1.2-.76-.77-1-.61-.29.68 0 1.21zm-6.68-7.54a1.62 1.62 0 00.74 1.28c.41.24.75.05.75-.42A1.65 1.65 0 0079 117c-.46-.22-.79 0-.79.43zm7.58 4.38a1.64 1.64 0 00.74 1.28c.41.23.74 0 .74-.43a1.64 1.64 0 00-.74-1.28c-.41-.26-.74-.07-.74.4zm-6.25.07c.29.5.76.77 1 .6s.29-.7 0-1.2-.76-.77-1-.61-.29.68 0 1.18zm5.35-3.06c.29.5.76.77 1 .61s.29-.71 0-1.21-.76-.77-1-.6-.29.67 0 1.17z"
                fill="#474756"
              />
              <path
                d="M85 121a1.55 1.55 0 01-.62 1.4s-.91.55-.93.55c-.39.22-.14-.28-.74-.63a4.84 4.84 0 01-2.2-3.79c0-.68-.63-.69-.24-.92l1-.56a1.55 1.55 0 011.54.17A4.84 4.84 0 0185 121z"
                fill="#545466"
              />
              <path
                d="M84.05 121.62c0 1.39-1 1.95-2.19 1.25a4.86 4.86 0 01-2.2-3.79c0-1.39 1-2 2.2-1.25a4.83 4.83 0 012.19 3.79z"
                fill="#545466"
              />
            </g>
            <g>
              <path
                fill="#cfdee8"
                d="M123.45 134.98v11.05l-33.06-19.09v-10.95l33.06 18.99z"
              />
              <path
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#e7f1f7"
                d="M99.81 121.48v10.64l-.53-.28v-10.67l.53.31z"
              />
              <path
                fill="#e7f1f7"
                d="M123.44 134.98v11.05l26.11-14.86v-11.11l-26.11 14.92zM149.55 120.06l-26.11 14.92-33.05-18.99 26.13-14.9 33.03 18.97z"
              />
            </g>
            <g fill="#545466">
              <path d="M119 127.62v3.67L0 62.09v-3.56l119 69.09z" />
              <path d="M118.99 127.62v3.67l32.65-18.57v-3.76l-32.65 18.66z" />
              <path d="M151.64 108.96l-32.65 18.66L0 58.53 32.67 39.9l118.97 69.06z" />
            </g>
            <g>
              <path
                fill="#cfdee8"
                d="M119 87.72v40.07L0 58.59V18.63l119 69.09z"
              />
              <path
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#e6e7e8"
                d="M116.18 89.34L2.82 23.53v33.44l113.36 65.92V89.34z"
              />
              <g fill="#dce8f1">
                <path
                  style={{
                    mixBlendMode: "multiply",
                  }}
                  d="M112.58 87.72l1.49.98v33.55l-1.49-.98V87.72zM114.14 88.57l.56-.03v33.55l-.56.03V88.57zM107.72 84.9l1.48.98v33.55l-1.48-.99V84.9zM109.27 85.74l.57-.02v33.55l-.57.02V85.74zM102.86 82.07l1.48.98v33.55l-1.48-.98V82.07zM104.41 82.92l.56-.03v33.55l-.56.03V82.92zM97.99 79.25l1.48.98v33.55l-1.48-.99V79.25zM99.54 80.09l.57-.02v33.55l-.57.02V80.09zM93.13 76.42l1.48.98v33.55l-1.48-.98V76.42zM94.68 77.27l.56-.03v33.55l-.56.02V77.27zM88.26 73.59l1.49.99v33.55l-1.49-.99V73.59zM89.81 74.44l.57-.02v33.55l-.57.02V74.44zM83.4 70.77l1.48.98v33.55l-1.48-.98V70.77zM84.95 71.62l.57-.03v33.55l-.57.02V71.62zM78.53 67.94l1.49.99v33.55l-1.49-.99V67.94zM80.09 68.79l.56-.02v33.55l-.56.02V68.79zM73.67 65.12l1.48.98v33.55l-1.48-.98V65.12zM75.22 65.97l.57-.03v33.55l-.57.02V65.97zM68.81 62.29l1.48.99v33.55l-1.48-.99V62.29zM70.36 63.14l.56-.02v33.55l-.56.02V63.14zM63.94 59.47l1.48.98V94l-1.48-.98V59.47zM65.49 60.31l.57-.02v33.55l-.57.02V60.31zM59.08 56.64l1.48.99v33.54l-1.48-.98V56.64zM60.63 57.49l.56-.02v33.54l-.56.03V57.49z"
                />
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M54.21 53.82l1.49.98v33.55l-1.49-.99V53.82zM55.77 54.66l.56-.02v33.55l-.56.02V54.66z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M49.35 50.99l1.48.98v33.55l-1.48-.98V50.99zM50.9 51.84l.57-.03v33.55l-.57.03V51.84z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M44.48 48.17l1.49.98V82.7l-1.49-.99V48.17zM46.04 49.01l.56-.02v33.55l-.56.02V49.01z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M39.62 45.34l1.48.98v33.55l-1.48-.98V45.34zM41.17 46.19l.57-.03v33.55l-.57.02V46.19z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M34.76 42.52l1.48.98v33.55l-1.48-.99V42.52zM36.31 43.36l.56-.02v33.55l-.56.02V43.36z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M29.89 39.69l1.49.98v33.55l-1.49-.98V39.69zM31.44 40.54l.57-.03v33.55l-.57.02V40.54z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M25.03 36.87l1.48.98V71.4l-1.48-.99V36.87zM26.58 37.71l.56-.02v33.55l-.56.02V37.71z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M20.16 34.04l1.49.98v33.55l-1.49-.98V34.04zM21.71 34.89l.57-.03v33.55l-.57.02V34.89z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M15.3 31.21l1.48.99v33.55l-1.48-.99V31.21zM16.85 32.06l.56-.02v33.55l-.56.02V32.06z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M10.43 28.39l1.49.98v33.55l-1.49-.98V28.39zM11.99 29.23l.56-.02v33.55l-.56.02V29.23z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M5.57 25.56l1.48.99v33.54l-1.48-.98V25.56zM7.12 26.41l.57-.02v33.55l-.57.02V26.41z"
                  />
                </g>
              </g>
              <path
                fill="#dce8f1"
                d="M118.99 87.72v40.07l32.65-18.57V69.06l-32.65 18.66z"
              />
              <path
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#e6e7e8"
                d="M148.82 107.58V73.92l-27.01 15.43v33.59l27.01-15.36z"
              />
              <path
                fill="#e7f1f7"
                d="M151.64 69.06l-32.65 18.66L0 18.63 32.67 0l118.97 69.06z"
              />
              <g fill="#dce8f1">
                <path
                  style={{
                    mixBlendMode: "multiply",
                  }}
                  d="M124.55 88.32l-1.48.99v33.55l1.48-.99V88.32zM123 89.17l-.56-.03v33.55l.56.03V89.17zM128.95 85.74l-1.48.98v33.55l1.48-.98V85.74zM127.4 86.59l-.57-.03v33.55l.57.02V86.59zM133.35 83.16l-1.49.98v33.55l1.49-.99V83.16zM131.79 84l-.56-.02v33.55l.56.02V84z"
                />
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M137.74 80.57l-1.48.98v33.55l1.48-.98V80.57zM136.19 81.42l-.56-.03v33.55l.56.03V81.42z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M142.14 77.99l-1.48.98v33.55l1.48-.99V77.99zM140.59 78.83l-.56-.02v33.55l.56.02V78.83z"
                  />
                </g>
                <g>
                  <path
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    d="M146.54 75.4l-1.49.99v33.55l1.49-.99V75.4zM144.99 76.25l-.57-.03v33.56l.57.02V76.25z"
                  />
                </g>
              </g>
            </g>
            <g>
              <path
                d="M151.5 84.57l21.5 12.5a11.07 11.07 0 015.28 6.92l3 11.91a44.31 44.31 0 011.36 10.88v13.93L152 158v-12.4a44.32 44.32 0 00-2-13.33L146.05 120a11.1 11.1 0 00-5.1-6.31l-20.07-11.7z"
                fill="red"
              />
              <path
                d="M152 145.58V158l-16.38-9.41-1.26-7.23-13.5-8v-31.42L141 113.68a11.12 11.12 0 015.12 6.34l3.88 12.34a44.26 44.26 0 012 13.22z"
                fill="#e50000"
              />
              <path
                d="M144.28 120.61l3.86 12.39a1 1 0 01-1.43 1.14L134.59 127a2.6 2.6 0 01-1.3-2.25v-10.13a1 1 0 011.47-.84l7.53 4.39a4.31 4.31 0 012 2.42z"
                fill="#26262e"
              />
              <path
                d="M147.21 133.87a.64.64 0 00.51-.26.62.62 0 00.09-.56l-3.87-12.34a4 4 0 00-1.82-2.24l-7.53-4.39h-.24c-.46 0-.71.23-.71.56v10.13a2.26 2.26 0 001.13 2l12.12 7.08z"
                fill="#616173"
              />
              <path
                d="M157.23 135.9v4.57a6.33 6.33 0 009.47 5.5l4.38-2.51a15.43 15.43 0 007.78-13.4v-6.6z"
                fill="#e50000"
              />
              <path
                d="M163.57 145.12a4.58 4.58 0 002.29-.62l4.38-2.51a13.78 13.78 0 006.93-11.93v-3.67l-18.25 10.49v3.59a4.66 4.66 0 004.65 4.65z"
                fill="#616173"
              />
              <path
                d="M175.67 136.27l-14.34 8.25a4.11 4.11 0 00.89.38l12.67-7.29a12 12 0 00.78-1.34zm1.23-3.52l-17.39 10a4.25 4.25 0 00.44.64l16.69-9.59c.1-.36.19-.7.26-1.05zm.27-3l-18.25 10.49v.21a4.77 4.77 0 00.05.66l18.17-10.45v-.62zm-18.25 7.67v.89l18.25-10.49V127z"
                fill="#474756"
                opacity={0.5}
              />
              <path
                d="M153.08 134.23a1.82 1.82 0 00.92-.23l24.84-14.09a3.05 3.05 0 001.44-3.39l-3.1-12.25a10 10 0 00-.66-1.83 1.13 1.13 0 00-1-.63 1 1 0 00-.53.14l-27.09 15.53a1.76 1.76 0 00-.78 2.09l4.23 13.43a1.8 1.8 0 001.73 1.27z"
                fill="#26262e"
              />
              <path
                d="M153.08 133.88a1.39 1.39 0 00.72-.19l24.83-14.09a2.71 2.71 0 001.29-3l-3.11-12.24a10.11 10.11 0 00-.64-1.77.77.77 0 00-.68-.44.68.68 0 00-.35.1l-27.06 15.53a1.44 1.44 0 00-.63 1.69l4.23 13.39a1.46 1.46 0 001.4 1.02z"
                fill="#616173"
              />
              <path
                d="M125.5 109.58l3.63 2.11a1.67 1.67 0 01.82 1.44v9.6a.2.2 0 01-.2.2l-3.47-2a1.56 1.56 0 01-.78-1.35v-10z"
                fill="#26262e"
              />
              <path
                d="M129.6 113.13a1.33 1.33 0 00-.6-1.13l-3.1-1.8v9.39a1.23 1.23 0 00.6 1l3.15 1.81z"
                fill="#616173"
              />
              <path
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="url(#servicescardphoto4__linear-gradient-10)"
                d="M134.18 132.49l-13.3.88 13.46 7.95-.16-8.83z"
              />
            </g>
            <path
              fill="#b4c4cc"
              d="M124.93 139.28v6.06l4.62-2.59-.31-6.04-4.31 2.57z"
            />
            <g>
              <path
                d="M145.49 151.84c0 2.47-.85 4.22-2.23 5.06l-4.26 2.45c-1.44.81-.52-1-2.71-2.28-4.4-2.55-8-8.7-8-13.75 0-2.5-2.31-2.52-.89-3.35 0 0 4.45-2.47 4.49-2.49 1.43-.78 3.4-.63 5.56.62 4.47 2.54 8.04 8.69 8.04 13.74z"
                fill="#4c4c5e"
              />
              <path
                d="M141.07 154.35c0 5.06-3.57 7.09-8 4.55s-8-8.7-8-13.75 3.57-7.08 8-4.54 8 8.69 8 13.74z"
                fill="#474756"
              />
              <path
                d="M138.78 153c0 3.6-2.54 5.05-5.68 3.24a12.51 12.51 0 01-5.68-9.8c0-3.6 2.54-5.05 5.68-3.23a12.49 12.49 0 015.68 9.79z"
                fill="#e7f1f7"
              />
              <path
                d="M138.78 153a4.88 4.88 0 01-.72 2.76c-1 .7-2.39.68-4-.24a11.67 11.67 0 01-5.3-9.14c0-2.43 1.24-3.8 3-3.75a6.22 6.22 0 011.28.58 12.49 12.49 0 015.74 9.79z"
                fill="#e7f1f7"
              />
              <path
                d="M129.86 142.53a3.94 3.94 0 00-1.64 3.63 12.51 12.51 0 005.68 9.8 4.52 4.52 0 003.24.7c-1 .61-2.46.52-4-.39a12.51 12.51 0 01-5.68-9.8c-.04-2.21.93-3.61 2.4-3.94z"
                fill="#474756"
              />
              <path
                d="M135.26 150.64c0 .94-.66 1.32-1.48.85a3.31 3.31 0 01-1.49-2.57c0-.94.67-1.32 1.49-.84a3.26 3.26 0 011.48 2.56z"
                fill="url(#servicescardphoto4__radial-gradient-4)"
              />
              <path
                d="M133.17 144.87a1.62 1.62 0 00.74 1.28c.41.24.74 0 .74-.42a1.64 1.64 0 00-.74-1.28c-.41-.24-.74-.05-.74.42zm0 8.69a1.62 1.62 0 00.74 1.28c.41.24.74 0 .74-.42a1.64 1.64 0 00-.74-1.28c-.41-.24-.74-.05-.74.42zm-1.41-8.83c-.29-.5-.76-.77-1-.61s-.29.71 0 1.21.76.77 1 .6.29-.7 0-1.2zm4.3 9.83c.29.5.76.78 1.05.61s.29-.7 0-1.2-.76-.77-1.05-.61-.29.71 0 1.2zm-6.68-7.56a1.62 1.62 0 00.74 1.28c.41.24.75.05.75-.42a1.65 1.65 0 00-.75-1.28c-.41-.21-.74-.02-.74.42zm7.62 4.4a1.61 1.61 0 00.74 1.28c.41.24.74 0 .74-.42a1.64 1.64 0 00-.74-1.28c-.45-.23-.74-.05-.74.42zm-6.25.07c.29.5.76.77 1 .61s.29-.71 0-1.21-.76-.77-1-.6-.33.73-.04 1.2zm5.35-3.05c.29.5.76.77 1.05.61s.29-.71 0-1.21-.76-.77-1.05-.6-.33.7-.04 1.2z"
                fill="#474756"
              />
              <path
                d="M136.21 150.64a1.57 1.57 0 01-.62 1.4l-.93.55c-.39.22-.14-.28-.74-.63a4.86 4.86 0 01-2.2-3.79c0-.69-.63-.69-.24-.92l1-.56a1.57 1.57 0 011.54.16 4.86 4.86 0 012.19 3.79z"
                fill="#545466"
              />
              <path
                d="M135.23 151.21c0 1.39-1 2-2.2 1.25a4.84 4.84 0 01-2.2-3.78c0-1.39 1-2 2.2-1.26a4.87 4.87 0 012.2 3.79z"
                fill="#545466"
              />
            </g>
            <path
              fill="#e7f1f7"
              d="M143.09 158.53v-8.77l-5.72-9.85-8.04-4.65 4.85-2.77 8.08 4.66 5.71 9.85v8.78l-4.88 2.75z"
            />
            <path
              fill="#dce8f1"
              d="M143.09 149.76l-5.72-9.85 4.89-2.76 5.71 9.85-4.88 2.76z"
            />
            <path
              fill="#cfdee8"
              d="M141.74 157.81v-7.69l-5.35-9.23-7.1-4.09-4.36 2.48v6.06l-1.34-.77v-6.07l5.71-3.26 8.07 4.67 5.72 9.85v8.82l-1.35-.77z"
            />
            <g>
              <path
                d="M184.92 137.76l-30.62 18.17a4.87 4.87 0 01-4.82 0l-5.72-3.2v5.21l5.77 3.25a4.89 4.89 0 004.84 0l30.55-17.54z"
                fill="#cfdee8"
              />
              <path
                d="M184.4 138.75l-30.1 17.18a4.87 4.87 0 01-4.82 0l-5.72-3.2 1.56-.9 4.15 2.34a4.85 4.85 0 004.86 0l28.27-16.31v-2.08l1.84 1.13a1.07 1.07 0 01-.04 1.84z"
                fill="#e7f1f7"
              />
              <g
                style={{
                  mixBlendMode: "color-dodge",
                }}
              >
                <path
                  fill="url(#servicescardphoto4__radial-gradient-5)"
                  d="M182.63 137.51l-.03.02-.01-1.75.03.03.01 1.7z"
                />
                <path
                  d="M144.09 152.54l5.43 3a4.87 4.87 0 004.82 0l30.09-17.18a1.1 1.1 0 00.5-.63 1.06 1.06 0 01-.53 1l-30.1 17.18a4.87 4.87 0 01-4.82 0l-5.72-3.2z"
                  fill="url(#servicescardphoto4__radial-gradient-6)"
                />
              </g>
            </g>
            <g>
              <path
                d="M120.82 92.65L151 75.37l11.35 6.82A16 16 0 01170.23 96l-30 17.12z"
                fill="#ff4a4a"
              />
              <path
                d="M140.17 113.05l-19.37-11.37v-9.09l11.44 6.66a16 16 0 017.93 13.8z"
                fill="#e50000"
              />
            </g>
            <path
              d="M158.89 148.34l-5.71 3.22a.79.79 0 01-1.18-.69v-2.49a2.15 2.15 0 011.14-1.9l1.79-.94a2.14 2.14 0 012.27.17L159 147a.79.79 0 01-.11 1.34zM182.63 133.13v2.07a.75.75 0 01-.42.67l-2.48 1.28a.59.59 0 01-.82-.73l1-2.7a1.57 1.57 0 01.81-.89l.82-.39a.76.76 0 011.09.69z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="#e7f1f7"
            />
            <path
              d="M158.89 147.92l-5.71 3.22a.79.79 0 01-1.18-.69V148a2.15 2.15 0 011.14-1.9l1.79-.94a2.14 2.14 0 012.27.16l1.77 1.3a.8.8 0 01-.08 1.3zM182.63 132.8v2.07a.75.75 0 01-.42.67l-2.48 1.28a.59.59 0 01-.82-.73l1-2.69a1.56 1.56 0 01.81-.9l.82-.39a.76.76 0 011.09.69z"
              fill="#ffc950"
            />
            <path
              d="M158.4 154.67l-4.29 2.45 1.26.84a2 2 0 002.07.07l4.42-2.59-1.6-.82a2 2 0 00-1.86.05zM183.87 140.32l-4.6 2.64a1.94 1.94 0 00-.85 1l-1.11 2.83 4.84-2.83a2 2 0 00.87-1.07zM176.3 148.54v-1a1.34 1.34 0 00-2-1.16l-8.79 5.05a4.4 4.4 0 00-2.21 3.82v.75z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="#e7f1f7"
            />
            <path
              fill="#e7f1f7"
              d="M165.77 152.23v2.35l8.49-4.8v-2.41l-8.49 4.86z"
            />
            <path
              d="M168.29 144.38c-6.53 3.48-11.27 7.35-10.57 8.66s6.55-.45 13.09-3.92 11.27-7.35 10.57-8.66-6.55.45-13.09 3.92z"
              style={{
                mixBlendMode: "color-dodge",
              }}
              fill="url(#servicescardphoto4__radial-gradient-7)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;

